import { Routes } from '@angular/router';
import { InicioComponent } from './inicio/inicio.component';
import { PaginaNoEncontradaComponent } from './pagina-no-encontrada/pagina-no-encontrada.component';
import { AcercadeComponent } from './acercade/acercade.component';
import { TestsComponent } from './tests/tests/tests.component';
import { MySqlListaUsuariosComponent } from './tests/mysql/mysql-lista-usuarios/mysql-lista-usuarios.component';

import { CouchBaseListaUsuariosComponent } from './tests/couch-base/couch-base-lista-usuarios/couch-base-lista-usuarios.component';
import { angularResolver, TestPadreAngularComponent } from './tests/angular/test-padre-angular/test-padre-angular.component';
import { TestHijoAngularComponent } from './tests/angular/test-hijo-angular/test-hijo-angular.component';
import { AngularTestTioAngularComponent, userResolver } from './tests/angular/test-tio-angular/angular-test-tio-angular.component';
import { MongoListaUsuariosComponent } from './tests/mongo/mongo-lista-usuarios/mongo-lista-usuarios.component';
import { KafkaComponent } from './tests/kafka/kafka.component';
import { VertxComponent } from './tests/vertx/vertx.component';
import { HazelcastComponent } from './tests/hazelcast/hazelcast.component';
import { PythonComponent } from './tests/python/python.component';
import { TypescriptComponent } from './tests/typescript/typescript.component';


export const routes: Routes = [
{ path: 'inicio', title: 'inicio', component: InicioComponent },
{ path: 'acercade', title: 'Acerca de ', component: AcercadeComponent },
{ path: 'tests/tests', title: 'Tests', component: TestsComponent },
{ path: 'tests/mysql', title: 'MySQL', component: MySqlListaUsuariosComponent },
{ path: 'tests/mongo', title: 'Mongo', component: MongoListaUsuariosComponent },
{ path: 'tests/couchbase', title: 'CouchBase', component: CouchBaseListaUsuariosComponent },
//{ path: 'tests/angular',  title: 'Angular', component: TestPadreAngularComponent, data: {dato_estatico: "Mi dato estatico"},resolve: {miclave: angularResolver} },
{ path: 'tests/angular',  title: 'Angular', component: TestPadreAngularComponent, data: {dato_estatico: "Mi dato estatico"} },
{ path: 'tests/kafka',  title: 'Angular', component: KafkaComponent },
{ path: 'tests/vertx',  title: 'Vertx', component: VertxComponent },
{ path: 'tests/hazelcast',  title: 'Hazelcast.', component: HazelcastComponent },
{ path: 'tests/python',  title: 'Python Flash', component: PythonComponent },
{ path: 'tests/typescript',  title: 'TypeScript Fastify', component: TypescriptComponent },
// carga diferida
//{ path: 'tests/angular', title: 'Angular', data: {dato_estatico: "Mi dato estatico"},resolve: {miclave: angularResolver},  loadComponent: () => import("./tests/angular/test-padre-angular/test-padre-angular.component").then(m => m.TestPadreAngularComponent)},
// Dos formas distintas de llamar al componente. con Resolver y con input
{ path: 'tests/angular/detalle_usuario_resolver',  title: 'Angular', component:  AngularTestTioAngularComponent, resolve:{usuario: userResolver} },
{ path: 'tests/angular/detalle_usuario_signal/:id',  title: 'Angular', component: AngularTestTioAngularComponent },
// carga diferida
{ path: '', redirectTo: 'inicio', pathMatch: 'full' },
{path: '**', component: PaginaNoEncontradaComponent },
];
